import React, { useContext, useState, useEffect } from "react";

import { callApi } from "bodycodi/cmap/app/js/common";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import AlramList from "./alramList";
import useObserver from "bodycodi/cmap/app/components/common/useObserver";
import LoadingSpinner from "bodycodi/cmap/app/components/common/loadingSpinner";

const AlramPopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ALRAM_POP", open: { alramPop: false } });
  };

  return (
    <CustomDialog open={state.alramPop} onClose={handleClose}>
      <PopupHeader title="알림" onClickBack={handleClose} />
      {state.alramPop && <AlramPop />}
    </CustomDialog>
  );
};

const AlramPop = () => {
  const [alarmState, setAlarmState] = useState({
    firstRendering: true,
    emptyPage: false,
    scrollEnd: false,
    pageNo: 0,
    alramList: [],
  });
  const listSize = 20;

  useEffect(() => {
    callApi(
      "/cmap6010/viewCoachAlarmList",
      {
        pageNo: 0,
        rowAmt: listSize,
      },
      "GET"
    ).then((res) => {
      setAlarmState((prev) => ({
        ...prev,
        firstRendering: false,
        emptyPage: res.length === 0 ? true : false,
        scrollEnd: res.length === listSize ? false : true,
        pageNo: 1,
        alramList: prev.alramList.concat(res),
      }));
    });
  }, []);

  const fetchItems = async () => {
    await callApi(
      "/cmap6010/viewCoachAlarmList",
      {
        pageNo: alarmState.pageNo * listSize,
        rowAmt: listSize,
      },
      "GET"
    ).then((res) => {
      setAlarmState((prev) => ({
        ...prev,
        scrollEnd: res.length === listSize ? false : true,
        pageNo: prev.pageNo + 1,
        alramList: prev.alramList.concat(res),
      }));
    });
  };

  const [_, setRef] = useObserver(async (entry: any, observer: any) => {
    observer.unobserve(entry.target);
    await fetchItems();
    observer.observe(entry.target);
  }, {});

  return (
    <section className="popup-body message-list">
      {alarmState.firstRendering ? (
        <div className="message-pop-loading">
          <LoadingSpinner />
        </div>
      ) : (
        <AlramList
          alramList={alarmState.alramList}
          setRef={setRef}
          scrollEnd={alarmState.scrollEnd}
          emptyPage={alarmState.emptyPage}
        />
      )}
    </section>
  );
};

export default AlramPopWrap;
